import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserFeelsService } from 'src/app/services/user-feels.service';

@Component({
  selector: 'app-weekly-report-chart-feel',
  templateUrl: './weekly-report-chart-feel.component.html',
  styleUrls: ['./weekly-report-chart-feel.component.scss']
})
export class WeeklyReportChartFeelComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Mood',
        fill: false,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#01E5BE',
      },
      {
        data: [  ],
        label: 'Worry',
        fill: false,
        tension: 0.5,
        borderColor: '#EF9742',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#EF9742',
        pointBorderColor:'#EF9742',
      },
      {
        data: [  ],
        label: 'Stress',
        fill: false,
        tension: 0.5,
        borderColor: '#E54B38',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#E54B38',
        pointBorderColor:'#E54B38',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 10,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "SCORE",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = true;


  constructor(private userFeelService: UserFeelsService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.datasets[1].data = [];
    this.lineChartData.datasets[2].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.lineChartData.labels?.push(
        weekNo+1
      );


      var weekTotals = this.userFeelService.getWeekScore(weekData);

      var mood = 0;
      var worry = 0;
      var stress = 0;
      if(weekTotals.totalDays > 0) {
        mood = Math.round(weekTotals.mood / weekTotals.totalDays);
        worry = Math.round(weekTotals.worry / weekTotals.totalDays);
        stress = Math.round(weekTotals.stress / weekTotals.totalDays);
      }


      this.lineChartData.datasets[0].data.push(mood);
      this.lineChartData.datasets[1].data.push(worry);
      this.lineChartData.datasets[2].data.push(stress);
    });
  }


}
